import React from 'react';
import withIcon from '../utilities/withIcon';

const IconNumber2 = () => {
  return (
    <g>
      <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm2.872 11.902H5.35v-1.083C7.599 9.1 9.2 7.994 9.2 6.463a1.218 1.218 0 0 0-1.271-1.377 1.171 1.171 0 0 0-1.213 1.247c.002.273.084.539.235.765l-1.224.495a2.145 2.145 0 0 1-.4-1.342 2.44 2.44 0 0 1 2.649-2.354 2.43 2.43 0 0 1 2.684 2.53c0 1.813-1.919 3.296-3.32 4.215h3.532v1.26z" />
    </g>
  );
};

export default withIcon(IconNumber2);
